"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.opal = void 0;
exports.opal = {
    baseTheme: 'opal',
    config: {
        colors: {
            palettes: {
                neutral: {
                    100: '#FFFFFF',
                    200: '#EBEBEC',
                    300: '#D6D6D6',
                    400: '#AAAAAA',
                    500: '#878787',
                    600: '#4D4D4D',
                    700: '#1A1A1A',
                    800: '#0D0D0D',
                },
                red: {
                    100: '#FCF0F0',
                    200: '#C7395B',
                    300: '#B90732',
                    400: '#940628',
                },
                orange: {
                    100: '#FDF3E6',
                    200: '#FAD33E',
                    300: '#E77D00',
                    400: '#C7A00B',
                },
                green: {
                    100: '#E2F1E7',
                    200: '#39C769',
                    300: '#07B944',
                    400: '#069436',
                },
                blue: {
                    100: '#ECF4FE',
                    200: '#9AC2FA',
                    300: '#4286F6',
                    400: '#2F6AD2',
                },
            },
            maps: {
                light: {
                    success: {
                        100: 'green.100',
                        200: 'green.200',
                        300: 'green.300',
                        400: 'green.400',
                    },
                    warning: {
                        100: 'orange.100',
                        200: 'orange.200',
                        300: 'orange.300',
                        400: 'orange.400',
                    },
                    danger: {
                        100: 'red.100',
                        200: 'red.200',
                        300: 'red.300',
                        400: 'red.400',
                    },
                    info: {
                        100: 'blue.100',
                        200: 'blue.200',
                        300: 'blue.300',
                        400: 'blue.400',
                    },
                    text: {
                        primary: 'neutral.800',
                        secondary: 'neutral.600',
                        placeholder: 'neutral.400',
                    },
                    background: {
                        opacity: 'neutral.800',
                        divider: 'neutral.300',
                        secondary: 'neutral.200',
                        primary: 'neutral.100',
                    },
                },
                dark: {
                    success: {
                        100: 'green.100',
                        200: 'green.200',
                        300: 'green.300',
                        400: 'green.400',
                    },
                    warning: {
                        100: 'orange.100',
                        200: 'orange.200',
                        300: 'orange.300',
                        400: 'orange.400',
                    },
                    danger: {
                        100: 'red.100',
                        200: 'red.200',
                        300: 'red.300',
                        400: 'red.400',
                    },
                    info: {
                        100: 'blue.100',
                        200: 'blue.200',
                        300: 'blue.300',
                        400: 'blue.400',
                    },
                    text: {
                        primary: 'neutral.100',
                        secondary: 'neutral.300',
                        placeholder: 'neutral.400',
                    },
                    background: {
                        opacity: 'neutral.800',
                        divider: 'neutral.600',
                        secondary: 'neutral.700',
                        primary: 'neutral.800',
                    },
                },
            },
            brand: {
                primary: '#0BB907',
                accessibleOverPrimary: '#0D0D0D',
            },
        },
        font: {
            pairing: 'modern',
        },
        borderRadius: {
            small: 1,
            medium: 1.5,
            large: 2,
            control: 0.625,
        },
    },
};
//# sourceMappingURL=opal.js.map